import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=daabe884&scoped=true"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"
import style0 from "./OptionList.vue?vue&type=style&index=0&id=daabe884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daabe884",
  null
  
)

export default component.exports